// extracted by mini-css-extract-plugin
export default {"main_input_section":"main-input_main_input_section__ybrj3","title":"main-input_title__vOchI","required":"main-input_required__Js3d4","main_input":"main-input_main_input__Ehcqf"};